import { useContext, useEffect } from "react";

import WebhookAction from "../components/WebhookAction";
import Request from "../components/Request";
import { Button, Card, Col, Row, Typography } from "antd";
import RequestHeader from "../components/RequestHeader";
import WebhookFields from "../components/WebhookFields";
import requests from "../lib/requests";
import { Link, useNavigate } from "react-router-dom";
import { NotificationContext } from "../context/NotificationProvider";
import FormField, { FormContext, FormProvider } from "../components/FormField";

function Webhook() {
  return (
    <Col style={{ padding: "20px" }}>
      <FormProvider>
        <WebhookComponents />
      </FormProvider>
    </Col>
  );
}

export default Webhook;

/**
 * -------------------------------
 * Webhook component is set here to enable us use Form Proivder and context
 * -------------------------------
 */
function WebhookComponents() {
  const { fields, setValue } = useContext(FormContext);
  const { setMessage } = useContext(NotificationContext);
  const navigate = useNavigate();

  useEffect(() => {
    setValue({
      method: "POST",
      webhook_for: "GENERIC",
    });
  }, []);

  const onSubmit = async (values: any) => {
    try {
      let formFields = { ...fields };

      let headers = null;
      if (Array.isArray(formFields.headers)) {
        if (formFields.headers.length) {
          const validheaders = formFields.headers.filter((header) => header[0]);
          const fdata = validheaders.map((head: any[]) => ({
            [head[0]]: head[1],
          }));

          headers = {};
          for (const h of fdata) {
            headers = { ...headers, ...h };
          }
        }
      }

      console.log(headers, "The headers");
      formFields.headers = headers;

      await requests.post(`/webhooks/register`, {
        ...formFields,
      });
      navigate("/");
    } catch (error: any) {
      const errors = error.response.data;
      if (errors.data) {
        console.log(errors.data, " all the error ");
        for (const message of errors.data) {
          setMessage({
            message: message.message,
            className: "failedRequest",
          });
        }
      }
      console.log(error.response.data, "updated error ");
    }
  };

  return (
    <FormField onSubmit={onSubmit}>
      <WebhookAction type={"new"} />
      <WebhookFields />
      <Request />
      <RequestHeader />
      <Card>
        <Row style={{ gap: "20px" }}>
          <Col>
            <Link to={"/"}>
              <Button htmlType="button" style={{ backgroundColor: "#8B0000" }}>
                <Typography.Text
                  style={{
                    color: "#fff",
                    textTransform: "uppercase",
                    fontWeight: "bold",
                  }}
                >
                  Cancelar
                </Typography.Text>
              </Button>
            </Link>
          </Col>
          <Col>
            {" "}
            <Button htmlType="submit" type="primary">
              <Typography.Text
                style={{
                  color: "#fff",
                  textTransform: "uppercase",
                  fontWeight: "bold",
                }}
              >
                Crear
              </Typography.Text>
            </Button>
          </Col>
        </Row>
      </Card>
    </FormField>
  );
}
